// extracted by mini-css-extract-plugin
export var childrenContainer = "_15-0";
export var virtualScrollArea = "_15-1";